import { AxiosRequestConfig } from "axios";
import adminApi from "./admin-api";

export class AdminBaseService {
  protected endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  protected get<T>(path: string = "", config?: AxiosRequestConfig): Promise<T> {
    return adminApi.get(`${this.endpoint}${path}`, config).then((r) => r.data);
  }

  protected post<T>(path: string = "", data?: any, config?: AxiosRequestConfig): Promise<T> {
    return adminApi.post(`${this.endpoint}${path}`, data, config).then((r) => r.data);
  }

  protected put<T>(path: string = "", data?: any, config?: AxiosRequestConfig): Promise<T> {
    return adminApi.put(`${this.endpoint}${path}`, data, config).then((r) => r.data);
  }

  protected patch<T>(path: string = "", data?: any, config?: AxiosRequestConfig): Promise<T> {
    return adminApi.patch(`${this.endpoint}${path}`, data, config).then((r) => r.data);
  }

  protected delete<T>(path: string = "", config?: AxiosRequestConfig): Promise<T> {
    return adminApi.delete(`${this.endpoint}${path}`, config).then((r) => r.data);
  }
}
